<template>
    <b-overlay :show="noDataYet" spinner-variant="primary">
        <b-container fluid="">
            <SearchSwitcherWrapper></SearchSwitcherWrapper>
            <b-row>
                <MapTableWrapper></MapTableWrapper>
                <RightPanel></RightPanel>
            </b-row>
        </b-container>
    </b-overlay>
</template>

<script>
    import {setDocumentTitle} from "../utils/i18n/document";
    // vuex
    import {mapGetters, mapActions} from "vuex";
    import {REFRESH_TOKEN} from "../store/actions/auth";
    // components
    import SearchSwitcherWrapper from "../components/search/SearchSwitcherWrapper";
    import RightPanel from "../components/dashboard/RightPanel";
    import MapTableWrapper from "../components/dashboard/MapTableWrapper";

    export default {
        name: "DashboardView",
        components: {
            MapTableWrapper,
            SearchSwitcherWrapper,
            RightPanel
        },
        async mounted() {
            setDocumentTitle(this.$t("dashboard.title"));
            await this.REFRESH_TOKEN();
        },
        computed: {
            ...mapGetters(['getPsData']),
            noDataYet() {
                return Object.keys(this.getPsData).length === 0;
            }
        },
        methods: {
            ...mapActions([REFRESH_TOKEN])
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/assets/scss/_variables";
</style>